module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-5-d763a398fce10ce302acedf1cd2665bc.png";